

































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import GlobalMixins from "../mixins";
import { IParty, IStatement } from "../interfaces";

const onClickaway = require("vue-clickaway");

@Component({
  directives: {
    onClickaway: onClickaway.directive,
  },
})
export default class Start extends GlobalMixins {
  languageModalOpen: boolean = false;
  hoveredLogoId: number = 0;

  get background(): false | { backgroundImage: string } {
    if (this.config.style.background) {
      return {
        backgroundImage: `url(gfx/img/${this.config.style.background})`,
      };
    } else {
      return false;
    }
  }
  get participatingParties(): IParty[] {
    return this.parties.filter((party) => {
      return party.participates;
    });
  }
  get nonParticipatingParties(): IParty[] {
    return this.parties.filter((party) => {
      return !party.participates;
    });
  }

  start() {
    this.trackGAEvent("start");

    this.$router.push({
      name: "statement",
      params: {
        id: "1",
        title: this.slugify(
          this.statementTitleToString(
            (this.$store.getters.statement(1) as IStatement).title
          )
        ),
      },
    });
  }

  created() {
    document.addEventListener("keyup", (e) => {
      if (e.code === "Escape") {
        this.hoveredLogoId = 0;
        this.languageModalOpen = false;
        (document.activeElement as HTMLElement)?.blur();
      }
    });
  }

}
